/**
 * The rows My bookings shows (Employee rebuild C3) — GET /space/me/bookings,
 * one shape for desks, rooms and parking in every building.
 */
import { downloadFile } from '@/utils/api';

export type BookingKind = 'desk' | 'room' | 'parking';

export interface AttendeeTally { invited: number; accepted: number; declined: number; tentative: number }

export interface MyBookingRow {
  kind: BookingKind;
  id: string;
  label: string;
  title: string | null;
  building_name: string | null;
  floor_name: string | null;
  /** The IANA zone of the row's building (else the organisation's). Every
   *  time on the row is shown in it (Employee fix, booking times). */
  timezone?: string | null;
  start: string;
  end: string | null;
  date: string;
  status: string;
  role: 'owner' | 'invitee';
  checked_in_at: string | null;
  check_in_opens_at: string | null;
  can_check_in: boolean;
  check_in_by: string | null;
  series_id: string | null;
  desk?: { desk_id: string; start_time: string; end_time: string; from_shift: boolean;
           swap_offer_id: string | null };
  room?: { room_id: string; requires_approval: boolean; attendees: AttendeeTally;
           my_rsvp: string | null; food_total: number | null; food_orders: number;
           av_requested: unknown; av_ticket_id: string | null; has_agenda: boolean;
           my_rating: number | null };
  parking?: { vehicle_number: string | null; amount: number | null };
  result: { kind: string; at: string | null } | null;
}

export const QK_MY_BOOKINGS = (view: 'upcoming' | 'past') => ['my-bookings', 'everything', view];

/** Download the booking's calendar file (Employee rebuild B10). */
export async function addToCalendar(row: Pick<MyBookingRow, 'kind' | 'id' | 'label' | 'date'>): Promise<void> {
  const safe = `${row.label} ${row.date}`.replace(/[^A-Za-z0-9 .-]+/g, '').trim() || 'booking';
  await downloadFile(`/space/calendar/${row.kind}/${row.id}.ics`, `${safe}.ics`);
}

/** "3 invited · 2 accepted · lunch for 6" — the room row's second line. */
export function roomSummary(row: MyBookingRow, foodLabel: (n: number) => string): string {
  const r = row.room;
  if (!r) return '';
  const parts: string[] = [];
  if (r.attendees.invited) {
    parts.push(`${r.attendees.invited} invited`);
    if (r.attendees.accepted) parts.push(`${r.attendees.accepted} accepted`);
  }
  if (r.food_orders && r.food_total != null) parts.push(foodLabel(r.food_total));
  return parts.join(' · ');
}
